var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowBlueLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.68461 0.13038L0.130548 7.68489C-0.0435159 7.85895 -0.0435159 8.14111 0.130548 8.31517L7.68461 15.8695C7.85867 16.0435 8.14083 16.0435 8.31489 15.8695L10.3277 13.8569C10.4112 13.7733 10.4583 13.6601 10.4583 13.5418C10.4583 13.4236 10.4112 13.3102 10.3277 13.2266L7.08887 9.98739L17.6848 9.98739C17.9309 9.98739 18.1306 9.78769 18.1306 9.54164L18.1306 6.45819C18.1306 6.21214 17.9309 6.01245 17.6848 6.01245L7.08909 6.01245L10.3279 2.77366C10.495 2.6065 10.495 2.31053 10.3279 2.14337L8.31512 0.130605C8.23154 0.0470277 8.1181 9.68073e-08 7.99997 9.53987e-08C7.88185 -0.000223066 7.76819 0.0468026 7.68461 0.13038Z",
    fill: "#074B60"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBlueLeft);
export default __webpack_public_path__ + "static/media/arrow_blue_left.bb83a4f5f3e557a3e71744fd512b9329.svg";
export { ForwardRef as ReactComponent };